/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { OverlayView, OverlayViewF } from '@react-google-maps/api'
import { useMemo, useState, type Dispatch } from 'react'
import { getIconName } from '../icon/icon.helper'
import { Icon } from '../icon/icon'
import { getPixelPositionMarker } from './map.helper'

import { cn } from '~/utils/misc'
import type { EventIndex } from '~/types/eventIndex'

export default function MapMarker({
	markers,
	active = false,
	onClick,
}: {
	markers: EventIndex[]
	active: boolean
	onClick: Dispatch<any>
}) {
	const [marker] = useState<EventIndex>(markers[0])
	const memoMarker = useMemo(() => {
		return (
			<OverlayViewF
				position={{ lat: marker.latitude, lng: marker.longitude }}
				mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
				getPixelPositionOffset={getPixelPositionMarker}
				zIndex={active ? 50 : 10}
			>
				<div
					onClick={() => onClick(markers)}
					className={cn(
						'flex h-[30px] cursor-pointer select-none items-center justify-center gap-x-1 whitespace-nowrap rounded-full border border-gray-400 px-2.5 py-0.5 align-middle text-sm font-semibold text-gray-700 transition-transform hover:scale-110 hover:bg-gray-200 hover:text-gray-900 md:h-[25px] md:text-xs',
						active ? 'scale-110 bg-gray-200 text-gray-900' : 'bg-white',
					)}
				>
					{markers.length > 1 && (
						<span className="-ml-2 flex h-6 w-6 items-center justify-center rounded-full bg-secondary text-center align-middle text-body-xs font-normal text-white md:h-5 md:w-5">
							{markers.length}
						</span>
					)}

					<Icon name={getIconName(marker.category.icon)} size="xs" />
					<span>{marker.shortDateTime}</span>
				</div>
			</OverlayViewF>
		)
	}, [active, markers, onClick])
	return memoMarker
}
